import { useDispatch, useSelector } from "react-redux";
import { getCurrentPage, getFilteredSavedAlbumsLength } from "../../reducers/albumListState";
import { useEffect, useState } from "react";
import { getCurrentAlbumListPageSize } from "../../reducers/userSettings";
import { savedAlbumsLoading } from "../../reducers/disablingProcesses";
import { setSavedAlbumsCurrentPage } from "../../actions/albumListActions";
import { PAGER_BUTTONS_AROUND_CURRENT } from "../../utils/constants/viewConstants";
import { anyAvailableDevice } from "../../reducers/devices";
import { useViewport } from "../others/useViewport";

export const useAlbumListPagerConfig = () => {
    const savedAlbumsLength = useSelector(getFilteredSavedAlbumsLength);
    const currentPage = useSelector(getCurrentPage);
    const albumListPageSize = useSelector(getCurrentAlbumListPageSize);
    const areAlbumsloading = useSelector(savedAlbumsLoading);
    const anyDevice = useSelector(anyAvailableDevice);

    const buttonsAroundCurrent = useViewport(PAGER_BUTTONS_AROUND_CURRENT);

    const disabled = !anyDevice || areAlbumsloading;

    const [ pagerButtonsInfo, setPagerButtonsInfo ] = useState([]);

    const dispatch = useDispatch();

    /**
     * This useEffect is executed when:
     * - The size for the album list pages is changed
     * - The number of saved albums loaded from Spotify is changed
     * - The current album list page is changed
     * - The process of loading saved albums has been started or finished
     */
    useEffect(() => {
        // If the saved albums are being loaded or there is no available device
        if(disabled)
        {
            // Nothing is done
            return;
        }

        const recalculateNPages = () => {
            // The number of pages is calculated based on the number of saved albums loaded and the size for the album list pages
            const nPages = albumListPageSize > 0 ? Math.ceil(savedAlbumsLength / albumListPageSize) : 0;

            // It is checked if the current page points to a page out of range
            if(nPages - 1 < currentPage)
            {
                // In that case, the pointer is reset to point to the new last page
                dispatch(setSavedAlbumsCurrentPage(nPages - 1));
            }

            return nPages;
        }

        const getPageButtonsInfo = (nPages) => {
            // If the number of pages is 0
            if(nPages === 0)
            {
                // Then, it won't be pager buttons
                return [];
            }
    
            var foundCurrentPage = false;
            var buttonsInfo = [];
            // It loops through the number of pages of the album list in order to build the array that will create the pager buttons
            for(var i = 0; i < nPages; i++)
            {
                if(i === 0 || i === nPages - 1 || (i > currentPage - buttonsAroundCurrent && i < currentPage + buttonsAroundCurrent)) {
                    if(i === currentPage) {
                        foundCurrentPage = true;
                    }

                    buttonsInfo = [...buttonsInfo, {
                        index: i,
                        text: i + 1,
                        current: i === currentPage
                    }];
                }
                else if ((i === 1 && (currentPage - buttonsAroundCurrent) === 1) || (i === (nPages - 2) && (currentPage + buttonsAroundCurrent) === (nPages - 2))) {
                    buttonsInfo = [...buttonsInfo, {
                        index: i,
                        text: i + 1,
                        current: false
                    }];
                }
                else if((foundCurrentPage && buttonsInfo.length < (buttonsAroundCurrent * 2 + 1)) || (!foundCurrentPage && i >= (nPages - (buttonsAroundCurrent * 2 + 1)))) {
                    buttonsInfo = [...buttonsInfo, {
                        index: i,
                        text: i + 1,
                        current: false
                    }];
                }
                else if(buttonsInfo[buttonsInfo.length - 1].index !== undefined)
                {
                    buttonsInfo = [...buttonsInfo, {
                        index: undefined,
                        text: '...',
                        current: false
                    }];
                }
            }

            return buttonsInfo;
        }

        const nPages = recalculateNPages();
        setPagerButtonsInfo(getPageButtonsInfo(nPages));

    // eslint-disable-next-line
    }, [albumListPageSize, savedAlbumsLength, currentPage, areAlbumsloading, buttonsAroundCurrent, dispatch]);

    return { currentPage, pagerButtonsInfo, disabled };
}